import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  template: `
      <h1 mat-dialog-title>Confirmation</h1>
      <div mat-dialog-content>
          <p>Êtes-vous sûr de vouloir signer et envoyer votre déclaration à l'agence ?</p>
          <br>
          <p>Toute modification ultérieure sera impossible</p>
      </div>
      <div mat-dialog-actions>
          <button mat-button (click)="onNoClick()">Non</button>
          <button mat-button (click)="onYesClick()" cdkFocusInitial>Oui</button>
      </div>
  `,
})
export class ConfirmationDialogComponent {
  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.dialogRef.close({ ok: true });
  }
}
